// Kabengwa Work on the Homepage images scroll
(() => {
  const section = document.querySelector(
    "#shopify-section-template--28132702454137__parallax_gallery_aYRAfQ",
  );
  if (!section) return;

  const heading =
    section.querySelector(".parallax-gallery__content .h1") ||
    section.querySelector(".parallax-gallery__content");

  const items = section.querySelectorAll(".parallax-gallery__item");
  if (!heading || !items.length) return;

  const SAFE_X = 10;
  const SAFE_Y = 8;

  // Shrink behavior
  const SHRINK_START = 150; // bigger = start shrinking earlier
  const MIN_SCALE = 0.42; // smaller floor = can shrink more

  // Move behavior
  const PUSH_START = 0.8; // start pushing only after ~this pressure
  const MAX_PUSH = 70;

  const FRAME_PADDING = 2; // keep item slightly inside the visible frame

  const clamp = (n, a, b) => Math.min(Math.max(n, a), b);
  const lerp = (a, b, t) => a + (b - a) * t;

  const expand = (r, x, y) => ({
    left: r.left - x,
    right: r.right + x,
    top: r.top - y,
    bottom: r.bottom + y,
  });

  const overlap = (a, b) =>
    !(
      a.right < b.left ||
      a.left > b.right ||
      a.bottom < b.top ||
      a.top > b.bottom
    );

  const edgeDist = (a, b) => {
    const dx = Math.max(a.left - b.right, b.left - a.right, 0);
    const dy = Math.max(a.top - b.bottom, b.top - a.bottom, 0);
    return Math.hypot(dx, dy);
  };

  let ticking = false;

  function update() {
    const c = heading.getBoundingClientRect();
    const zone = expand(c, SAFE_X, SAFE_Y);
    const zcx = (zone.left + zone.right) / 2;
    const zcy = (zone.top + zone.bottom) / 2;

    // Frame we must not push outside of
    const frameEl =
      section.querySelector(".parallax-gallery__images") ||
      section.querySelector(".parallax-gallery") ||
      section;
    const frameRect = frameEl.getBoundingClientRect();

    const frameMinX = frameRect.left + FRAME_PADDING;
    const frameMaxX = frameRect.right - FRAME_PADDING;
    const frameMinY = frameRect.top + FRAME_PADDING;
    const frameMaxY = frameRect.bottom - FRAME_PADDING;

    items.forEach((item) => {
      const target = item.querySelector(".responsive-image");
      if (!target) return;

      const r = item.getBoundingClientRect();
      const ir = { left: r.left, right: r.right, top: r.top, bottom: r.bottom };

      const d = edgeDist(zone, ir);
      const isOverlap = overlap(zone, ir);

      if (!isOverlap && d > SHRINK_START) {
        target.style.transform = "translate3d(0px,0px,0px) scale(1)";
        return;
      }

      const t = clamp((SHRINK_START - d) / SHRINK_START, 0, 1);
      const scale = lerp(1, MIN_SCALE, t);

      let pushX = 0;
      let pushY = 0;

      // Only push when very close/overlap (keeps "shrink-first" behavior)
      if (isOverlap || t >= PUSH_START || scale <= MIN_SCALE + 0.001) {
        const icx = (ir.left + ir.right) / 2;
        const icy = (ir.top + ir.bottom) / 2;

        const vx = icx - zcx;
        const vy = icy - zcy;
        const len = Math.hypot(vx, vy) || 1;
        const ux = vx / len;
        const uy = vy / len;

        const pressure = isOverlap ? 1 : t;
        const push = lerp(0, MAX_PUSH, pressure);

        pushX = ux * push;
        pushY = uy * push;

        // Clamp translation so the item doesn't go outside the frame
        const desiredLeft = ir.left + pushX;
        const desiredRight = ir.right + pushX;
        if (desiredLeft < frameMinX) pushX = frameMinX - ir.left;
        if (desiredRight > frameMaxX) pushX = frameMaxX - ir.right;

        const desiredTop = ir.top + pushY;
        const desiredBottom = ir.bottom + pushY;
        if (desiredTop < frameMinY) pushY = frameMinY - ir.top;
        if (desiredBottom > frameMaxY) pushY = frameMaxY - ir.bottom;
      }

      target.style.transform = `translate3d(${pushX.toFixed(1)}px,${pushY.toFixed(1)}px,0) scale(${scale.toFixed(3)})`;
    });

    ticking = false;
  }

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  window.addEventListener("scroll", requestUpdate, { passive: true });
  window.addEventListener("resize", requestUpdate);
  window.addEventListener("load", requestUpdate);

  requestUpdate();
  setTimeout(requestUpdate, 500);
  setTimeout(requestUpdate, 1200);
})();

// Ssali Propser work on the Red Dot
(function () {
  // =======================
  // sold badge style
  // ========================
  const injectGlobalSoldStyles = () => {
    if (document.getElementById("global-sold-badge-style")) return;

    const style = document.createElement("style");
    style.id = "global-sold-badge-style";
    style.textContent = `
    .sold-badge {
      position: absolute;
      top: 16px;
      left: 16px;

      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 6px 12px;
      border-radius: 999px;

      background: rgba(0,0,0,0.8);
      color: #fff;
      font-weight: 600;
      font-size: 12px;
      letter-spacing: 0.08em;
      z-index: 100;
      box-shadow: 0 4px 12px rgba(0,0,0,0.25);
      animation: soldFadeIn 0.25s ease;
    }

    .sold-badge .sold-dot {
      width: 8px;
      height: 8px;
      background: #ff3b30;
      border-radius: 50%;
      flex-shrink: 0;
    }

    @keyframes soldFadeIn {
      from { opacity: 0; transform: translateY(-4px); }
      to { opacity: 1; transform: translateY(0); }
    }
  `;
    document.head.appendChild(style);
  };

  injectGlobalSoldStyles();

  const injectResponsiveStyles = () => {
    if (document.getElementById("responsive-badge-styles")) return;
    const style = document.createElement("style");
    style.id = "responsive-badge-styles";
    style.textContent = `
    @media (max-width: 767px) {
      .hide-on-mobile {
        display: none !important;
      }
    }
  `;
    document.head.appendChild(style);
  };
  injectResponsiveStyles();

  const isProductPage = Boolean(
    document.querySelector('[id^="ProductSubmitButton"]'),
  );
  const applyStyles = (el, styles) => Object.assign(el.style, styles);

  // Updated to EXACTLY match your .sold-badge CSS, but relative for the grid
  const badgeStyles = {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "6px 12px",
    backgroundColor: "rgba(0,0,0)",
    color: "#fff",
    fontWeight: "600",
    fontSize: "12px",
    height: "30px",
    letterSpacing: "0.08em",
    borderRadius: "999px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
    animation: "soldFadeIn 0.25s ease",
    border: "none",
    float: "left",
    marginRight: "15px",
    marginTop: "5px",
    zIndex: "10",

    // NEW FIXES FOR HEIGHT CONSISTENCY:
    lineHeight: "1", // Prevents theme line-height from stretching it
    minHeight: "unset", // Removes theme default minimum height
    maxHeight: "32px", // Locks the maximum height
    boxSizing: "border-box", // Ensures padding is calculated correctly
  };

  let productIsSold = false;

  // ---------- Sold badges on shop pages ----------
  document.querySelectorAll(".price__badge-sold-out").forEach((badge) => {
    if (isProductPage) {
      badge.style.display = "none";
      return;
    }

    applyStyles(badge, badgeStyles);

    // Using your exact red dot styling
    badge.innerHTML = `
      <span style="
        width: 8px;
        height: 8px;
        background: #ff3b30;
        border-radius: 50%;
        flex-shrink: 0;
        display: inline-block;
      "></span>
      <span style="display: inline-block;">SOLD</span>
    `;

    const parent = badge.parentElement;
    if (parent) {
      applyStyles(parent, {
        display: "block",
        width: "100%",
        overflow: "hidden",
      });
    }
  });

  // ---------- Remove preview popup sold message ----------
  const removePreviewSoldText = () => {
    document.querySelectorAll(".price__badge-sold-out").forEach((el) => {
      if (
        el.textContent.toLowerCase().includes("this unique piece has been sold")
      ) {
        el.remove();
      }
    });
  };
  removePreviewSoldText();
  setTimeout(removePreviewSoldText, 500);
  setTimeout(removePreviewSoldText, 1000);
  setTimeout(removePreviewSoldText, 2000);
  // ---------- REMOVE SOLD PRODUCTS FROM "YOU MAY ALSO LIKE" ----------
  const removeSoldRecommendations = () => {
    document
      .querySelectorAll(".card-wrapper, .card, .grid__item")
      .forEach((card) => {
        const soldText = card.textContent?.toLowerCase();
        if (soldText && soldText.includes("this unique piece has been sold")) {
          card.remove();
        }
      });
  };
  removeSoldRecommendations();
  setTimeout(removeSoldRecommendations, 500);
  setTimeout(removeSoldRecommendations, 1200);
  setTimeout(removeSoldRecommendations, 2000);
  // ---------- Product page button ----------
  if (isProductPage) {
    document
      .querySelectorAll('[id^="ProductSubmitButton"]')
      .forEach((button) => {
        const text = button.querySelector("span");
        if (
          text &&
          text.textContent
            .toLowerCase()
            .includes("this unique piece has been sold")
        ) {
          productIsSold = true;
          text.textContent = "SOLD";
          applyStyles(button, {
            backgroundColor: "#2c2e2f",
            color: "#fff",
            opacity: "1",
            border: "none",
            fontFamily: "inherit",
            letterSpacing: "0.15em",
          });
        }
      });
    // ---------- Remove PayPal / dynamic checkout if sold ----------
    if (productIsSold) {
      document
        .querySelectorAll(".shopify-payment-button")
        .forEach((el) => el.remove());
      document
        .querySelectorAll(".shopify-payment-button__button")
        .forEach((el) => el.remove());
      document
        .querySelectorAll(".shopify-payment-button__more-options")
        .forEach((el) => el.remove());
    }
  }
  // ---------- Brendan Murphy indicator ----------
  // if (productIsSold) {
  //   document
  //     .querySelectorAll(
  //       "p.product__text.inline-richtext.sub-heading, p.product__vendor",
  //     )
  //     .forEach((el) => {
  //       if (
  //         el.textContent.includes("BRENDAN MURPHY") &&
  //         !el.querySelector(".red-dot-status")
  //       ) {
  //         // Remove the flex styles from the paragraph entirely

  //         const dot = document.createElement("span"); // Use span instead of div
  //         dot.className = "red-dot-status";

  //         Object.assign(dot.style, {
  //           display: "inline-block",
  //           width: "0.8em",
  //           height: "0.8em",
  //           backgroundColor: "#ff0000",
  //           borderRadius: "50%",
  //           marginLeft: "4px", // Replaces the flex gap
  //           verticalAlign: "middle", // Aligns mathematically with text
  //           position: "relative",
  //           top: "-1px", // Fine-tune optical center for all-caps
  //         });

  //         el.appendChild(dot);
  //       }
  //     });
  // }
  // ---------- FIX AJAX LOADING ----------
  const observer = new MutationObserver(() => {
    removeSoldRecommendations();
    document
      .querySelectorAll('[id^="ProductSubmitButton"]')
      .forEach((button) => {
        const text = button.querySelector("span");
        if (
          text &&
          text.textContent
            .toLowerCase()
            .includes("this unique piece has been sold")
        ) {
          text.textContent = "SOLD";
          applyStyles(button, {
            backgroundColor: "#2c2e2f",
            color: "#fff",
            opacity: "1",
            border: "none",
            fontFamily: "inherit",
            letterSpacing: "0.15em",
          });
          document.querySelectorAll(".price__badge-sold-out").forEach((el) => {
            if (
              el.textContent
                .toLowerCase()
                .includes("this unique piece has been sold")
            )
              el.remove();
          });
          document
            .querySelectorAll(".shopify-payment-button")
            .forEach((el) => el.remove());
          document
            .querySelectorAll(".shopify-payment-button__button")
            .forEach((el) => el.remove());
          document
            .querySelectorAll(".shopify-payment-button__more-options")
            .forEach((el) => el.remove());
        }
      });
  });

  observer.observe(document.body, { childList: true, subtree: true });
  // ---------- PRODUCT PAGE IMAGE BADGE ----------
  const productImageBadgeStyles = {
    position: "absolute",
    top: "15px",
    left: "15px",
    width: "100px",
    display: "flex",
    gap: "4px",
    justifyContent: "center",
    alignItems: "center",
    height: "40px",
    backgroundColor: "#000",
    color: "#fff",
    padding: "6px 6px",
    fontWeight: "bold",
    fontSize: "11px",
    letterSpacing: "0.12em",
    zIndex: "100",
    lineHeight: "1",
  };

  const updateImageSoldBadge = (container) => {
    if (!productIsSold) return;
    container
      .querySelectorAll(".image-sold-badge")
      .forEach((el) => el.remove());
    const activeMedia =
      container.querySelector(
        '.product__media-item[aria-hidden="false"] .product__media',
      ) ||
      container.querySelector(".product__media") ||
      container.querySelector("img");
    if (!activeMedia) return;
    activeMedia.style.position = "relative";
    const badge = document.createElement("div");
    badge.className = " sold-badge hide-on-mobile";
    badge.innerHTML = `
      <span class="sold-dot"></span>
      <span>SOLD</span>
    `;
    applyStyles(badge, productImageBadgeStyles);
    activeMedia.appendChild(badge);
  };
  // Run initially on main product images
  setTimeout(() => updateImageSoldBadge(document), 500);
  // Watch product gallery
  const gallery = document.querySelector(".product__media-list");
  if (gallery) {
    new MutationObserver(() => updateImageSoldBadge(document)).observe(
      gallery,
      {
        subtree: true,
        attributes: true,
        attributeFilter: ["aria-hidden"],
      },
    );
  }
  // ---------- SOLD BADGE FOR LIGHTBOX SLIDER ----------
  const updateSliderSoldBadge = () => {
    if (!productIsSold) return;
    document.querySelectorAll(".pswp__item").forEach((slide) => {
      slide.querySelectorAll(".image-sold-badge").forEach((el) => el.remove());
      const img = slide.querySelector("img");
      if (!img) return;
      img.style.position = "relative";
      const badge = document.createElement("div");
      badge.className = "image-sold-badg sold-badge";
      badge.innerHTML = `
        <span class="sold-dot"></span>
        <span>SOLD</span>
      `;
      applyStyles(badge, productImageBadgeStyles);
      slide.appendChild(badge);
    });
  };
  // Initial run
  setTimeout(updateSliderSoldBadge, 500);
  // Observe slider for new slides
  document.querySelectorAll(".pswp__item").forEach((slide) => {
    new MutationObserver(updateSliderSoldBadge).observe(slide, {
      subtree: true,
      childList: true,
    });
  });

  // =====================================================
  // FULLSCREEN SLIDER (ROBUST DETECTION)
  // =====================================================
  let sliderInitialized = false;
  const initSliderWatcher = () => {
    const bodyObserver = new MutationObserver(() => {
      const pswp = document.querySelector(".pswp");

      // NEW FIX: If slider doesn't exist, or is hidden/closed, reset our lock!
      if (
        !pswp ||
        getComputedStyle(pswp).display === "none" ||
        pswp.getAttribute("aria-hidden") === "true"
      ) {
        sliderInitialized = false;
        return; // Stop here until it opens again
      }

      // if slider is actively open and already initialized OR product not sold → skip
      if (sliderInitialized || !productIsSold) return;

      // Lock it so we don't attach multiple observers while it remains open
      sliderInitialized = true;

      const applyBadge = () => {
        const activeSlide = pswp.querySelector(
          '.pswp__item[aria-hidden="false"]',
        );
        if (!activeSlide) return;
        const zoomWrap = activeSlide.querySelector(".pswp__zoom-wrap");
        if (!zoomWrap) return;

        // remove old badge
        zoomWrap
          .querySelectorAll(".slider-sold-badge")
          .forEach((el) => el.remove());
        zoomWrap.style.position = "relative";
        const badge = document.createElement("div");
        badge.className = "slider-sold-badge sold-badge";
        badge.innerHTML = `
        <span class="sold-dot"></span>
        <span>SOLD</span>
      `;
        Object.assign(badge.style, {
          position: "absolute",
          top: "15px",
          left: "15px",
          backgroundColor: "#000",
          color: "#fff",
          padding: "6px 12px",
          display: "flex",
          alignItems: "center",
          fontSize: "14px",
          fontWeight: "bold",
          letterSpacing: "0.12em",
          zIndex: "9999",
        });
        zoomWrap.appendChild(badge);
      };

      // run immediately on first open
      applyBadge();

      // watch slide changes while open
      const slideObserver = new MutationObserver(() => {
        applyBadge();
      });
      slideObserver.observe(pswp, {
        subtree: true,
        attributes: true,
        attributeFilter: ["aria-hidden", "class"],
      });
    });

    // UPDATED FIX: We added 'attributes' to ensure we catch when the slider changes from hidden to visible
    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style", "aria-hidden"],
    });
  };
  // start watching
  initSliderWatcher();

  // =====================================================
  // SPLIDE CAROUSEL SOLD BADGE (QUICK OVERVIEW SLIDER - MOBILE ONLY)
  // =====================================================
  const addSplideSoldBadges = () => {
    // run ONLY on small screens
    if (!productIsSold || window.innerWidth > 767) return;
    document
      .querySelectorAll(".splide__slide .product-media-container")
      .forEach((container) => {
        // avoid duplicates
        if (container.querySelector(".splide-sold-badge")) return;
        container.style.position = "relative";
        const badge = document.createElement("div");
        badge.className = "splide-sold-badge sold-badge";
        badge.innerHTML = `
      <span class="sold-dot"></span>
      <span>SOLD</span>
    `;
        Object.assign(badge.style, {
          position: "absolute",
          top: "15px",
          left: "15px",
          width: "100px",
          height: "40px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "#000",
          color: "#fff",
          fontWeight: "bold",
          fontSize: "1.2em",
          letterSpacing: "0.12em",
          zIndex: "100",
          lineHeight: "1",
        });
        container.appendChild(badge);
      });
  };
  // run once
  setTimeout(addSplideSoldBadges, 600);
  // observe slider updates
  const splideObserver = new MutationObserver(() => {
    addSplideSoldBadges();
  });
  splideObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // =====================================================
  // QUICK VIEW SLIDER sold TEXT (PROFESSIONAL BADGE)
  // =====================================================
  const STYLE_ID = "quickview-sold-badge-style";

  const injectSoldStyles = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement("style");
    style.id = STYLE_ID;

    style.textContent = `
    .quickview-sold-text {
      position: absolute;
      top: 16px;
      left: 16px;

      display: inline-flex;
      align-items: center;
      gap: 8px;

      padding: 6px 12px;
      border-radius: 999px;

      background: rgba(0, 0, 0);
    

      color: #ffffff;
      font-weight: 600;
      font-size: 12px;
      letter-spacing: 0.08em;

      z-index: 100;
      box-shadow: 0 4px 12px rgba(0,0,0,0.25);

      animation: soldFadeIn 0.25s ease;
    }

    .quickview-sold-text .sold-dot {
      width: 8px;
      height: 8px;
      background: #ff3b30;
      border-radius: 50%;
      flex-shrink: 0;
    }

    @keyframes soldFadeIn {
      from { opacity: 0; transform: translateY(-4px); }
      to { opacity: 1; transform: translateY(0); }
    }
  `;

    document.head.appendChild(style);
  };

  const addQuickViewsold = () => {
    injectSoldStyles();

    const quickView = document.querySelector(
      ".quick-add-modal, .product-quick-view, .quick-view",
    );
    if (!quickView) return;

    quickView
      .querySelectorAll(".splide__slide .product-media-container")
      .forEach((container) => {
        if (container.querySelector(".quickview-sold-text")) return;

        const addToCartButton = container
          .closest(".quick-view, .product-quick-view, .quick-add-modal")
          ?.querySelector('[id^="ProductSubmitButton"]');

        const btnText =
          addToCartButton?.querySelector("span")?.textContent?.toLowerCase() ||
          "";

        const isSold =
          btnText.includes("sold") ||
          btnText.includes("this unique piece has been sold");

        if (!isSold) return;

        container.style.position = "relative";

        const sold = document.createElement("div");
        sold.className = "quickview-sold-text";

        //  clean structure (no inline styles)
        sold.innerHTML = `
      <span class="sold-dot"></span>
      <span>SOLD</span>
    `;

        container.appendChild(sold);
      });
  };

  // run once after short delay
  setTimeout(addQuickViewsold, 700);

  // observe dynamic modal updates
  const soldObserver = new MutationObserver(addQuickViewsold);

  soldObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  //==============================================
  // overview dot
  //==============================================

  // const applyBrendanDotInModal = () => {
  //   const quickView = document.querySelector(
  //     ".quick-add-modal, .product-quick-view, .quick-view",
  //   );

  //   if (!quickView) return;

  //   quickView
  //     .querySelectorAll("p.product__text.inline-richtext.sub-heading")
  //     .forEach((el) => {
  //       // avoid duplicates
  //       if (el.querySelector(".red-dot")) return;

  //       // compute "sold" INSIDE modal
  //       const addToCartButton = el
  //         .closest(".quick-view, .product-quick-view, .quick-add-modal")
  //         ?.querySelector('[id^="ProductSubmitButton"]');

  //       const isSold =
  //         addToCartButton &&
  //         addToCartButton.querySelector("span") &&
  //         addToCartButton
  //           .querySelector("span")
  //           .textContent.toLowerCase()
  //           .includes("sold");

  //       if (!isSold) return;

  //       if (!el.textContent.includes("BRENDAN MURPHY")) return;

  //       // apply layout
  //       el.style.display = "inline-flex";
  //       el.style.alignItems = "center";
  //       el.style.gap = "6px";

  //       const dot = document.createElement("span");
  //       dot.className = "red-dot";

  //       Object.assign(dot.style, {
  //         width: "0.8em",
  //         height: "0.8em",
  //         background: "red",
  //         borderRadius: "50%",
  //         flexShrink: "0",
  //       });

  //       el.appendChild(dot);
  //     });
  // };
  // setTimeout(applyBrendanDotInModal, 700);

  // const brendanObserver = new MutationObserver(() => {
  //   applyBrendanDotInModal();
  // });

  // brendanObserver.observe(document.body, {
  //   childList: true,
  //   subtree: true,
  // });

  // -------------------------------------------------------------------------------------------------------------------------------------------
})();

// -------------------------------------------------------------------------------------------------------------------------------------------

// Kabengwa Work on the Rearrangig the images on about us page

(() => {
  const MOBILE_QUERY = "(max-width: 989px)";
  const mq = window.matchMedia(MOBILE_QUERY);

  function getOriginalBlocks(row) {
    const current = Array.from(row.children).filter((el) =>
      el.classList.contains("custom-block"),
    );

    // Save original index once
    if (!row.dataset.originalOrderSaved) {
      current.forEach((el, i) => {
        el.dataset.originalIndex = String(i);
      });
      row.dataset.originalOrderSaved = "true";
    }

    // Always derive from original desktop sequence
    return current.sort(
      (a, b) =>
        Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex),
    );
  }

  function reorderRowForMobile(row) {
    const original = getOriginalBlocks(row);
    const reordered = [];

    // Pair blocks in their original 2-column chunks
    for (let i = 0; i < original.length; i += 2) {
      const chunk = original.slice(i, i + 2);

      const imageBlock = chunk.find(
        (el) =>
          el.dataset.blockType === "image" || el.id.includes("block-image"),
      );
      const textBlock = chunk.find(
        (el) => el.dataset.blockType === "text" || el.id.includes("block-text"),
      );
      const others = chunk.filter(
        (el) => el !== imageBlock && el !== textBlock,
      );

      if (imageBlock) reordered.push(imageBlock);
      if (textBlock) reordered.push(textBlock);
      reordered.push(...others);
    }

    reordered.forEach((el) => row.appendChild(el));
  }

  function restoreDesktopOrder(row) {
    const blocks = Array.from(row.children).filter((el) =>
      el.classList.contains("custom-block"),
    );

    blocks
      .sort(
        (a, b) =>
          Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex),
      )
      .forEach((el) => row.appendChild(el));
  }

  function applyLayoutOrder() {
    const rows = document.querySelectorAll(
      ".section--custom-content .row.section-custom-content",
    );
    rows.forEach((row) => {
      if (mq.matches) {
        reorderRowForMobile(row);
      } else {
        restoreDesktopOrder(row);
      }
    });
  }

  window.addEventListener("load", applyLayoutOrder);
  window.addEventListener("resize", applyLayoutOrder);
  document.addEventListener("shopify:section:load", applyLayoutOrder);
  document.addEventListener("shopify:section:reorder", applyLayoutOrder);
  document.addEventListener("shopify:block:select", applyLayoutOrder);
})();

// Hussein Work on the slider issue.
(function () {
  function enhancePressCarousel(section) {
    const main = section.querySelector("#Press-main");
    const thumbnails = section.querySelector("#Press-thumbnail");

    if (!main || !thumbnails) return;

    const slides = main.querySelectorAll(".splide__slide");
    const logos = thumbnails.querySelectorAll("img");

    slides.forEach((slide, index) => {
      if (slide.querySelector(".press-thumbnail__item")) return;

      const logo = logos[index];
      if (!logo) return;

      const wrapper = document.createElement("div");
      wrapper.className = "press-thumbnail__item mx-auto";

      const width = logo.getAttribute("width") || 150;
      wrapper.style.setProperty("--image-width", width + "px");

      const img = logo.cloneNode(true);
      img.removeAttribute("srcset");
      img.style.maxWidth = "100%";
      img.style.height = "auto";

      wrapper.appendChild(img);
      slide.appendChild(wrapper);
    });

    thumbnails.style.display = "none";
  }

  function init() {
    document.querySelectorAll("async-carousel").forEach(enhancePressCarousel);
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();

// Hussein work on the removing of the anchor tag on the user's name

(function () {
  function removeVendorLinks() {
    document.querySelectorAll(".product__vendor a").forEach((anchor) => {
      const text = document.createTextNode(anchor.textContent);
      anchor.replaceWith(text);
    });
  }

  document.addEventListener("DOMContentLoaded", removeVendorLinks);
  document.addEventListener("shopify:section:load", removeVendorLinks);
})();
